<template>
  <!-- 公共 header nav -->
  <div
    :class="[
      'page_header_wrapper',
      { gradual: active == 1 && page != 0 },
      { bgfff: visible },
    ]"
    :style="{ backgroundColor: bg }"
  >
    <div class="page_header">
      <div
        class="logo_box"
        :class="name == 'case' || visible ? 'b_logo' : ''"
      ></div>
      <ul class="nav_ul">
        <router-link
          tag="li"
          :to="{ path: nav.url }"
          v-for="(nav, index) in nav_data"
          :key="index"
        >
          <div
            class="hand"
            :class="[{ active: active == index + 1 }, 'title']"
            @mouseover="mouseOver(index)"
            @mouseleave="mouseLeave(index)"
          >
            <span
              v-if="name == 'index'"
              class="c_fff"
              :class="name == 'case' || visible ? 'c_333' : 'c_fff'"
              >{{ nav.name }}</span
            >
            <span
              v-else
              class="normal_text"
              :class="name == 'case' || visible ? 'c_333' : 'c_fff'"
              >{{ nav.name }}</span
            >
            <i v-if="index == 1 && visible" class="orange_up"></i>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageNav",
  props: {
    active: {
      type: [String, Number],
      required: false,
      default: 1,
    },
    bg: {
      type: String,
      required: false,
      default: "transparent",
    },
    page: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    name: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      flag: false,
      dropData: [],
      nav_data: [
        {
          name: "首页",
          url: "/",
        },
        {
          name: "产品&解决方案",
          url: "/solution",
        },
        {
          name: "客户案例",
          url: "/case",
        },
        {
          name: "核心技术",
          url: "/technology",
        },
        {
          name: "新闻动态",
          url: "/news",
        },
        {
          name: "党建+公益",
          url: "/party",
        },
        {
          name: "关于我们",
          url: "/about",
        },
      ],
      flag: false,
      path: "",
      str: "",
    };
  },
  methods: {
    // 移入
    mouseOver(index) {
      if (index == 1) {
        this.flag = true;
      } else {
        this.flag = false;
      }
      this.$emit("changeMover", this.flag, "");
    },
    // 移出
    mouseLeave(index) {
      this.str = "";
      if (index == 1) {
        this.flag = false;
        this.str = "pageNav";
      } else {
        this.flag = false;
      }
      this.$emit("changeMover", this.flag, this.str);
    },
  },
  mounted() {
    this.path = this.$route.path;
  },
};
</script>
<style lang="scss" scoped>
.b_logo {
  // width: 127px !important;
  // height: 28px !important;
  // background-size: 100% 100%;
  background-image: url(../../static/images/b_logo.png)!important;
}

.page_header_wrapper {
  width: 100%;
  height: 80px;
  position: absolute;
  z-index: 9999;

  .page_header {
    max-width: 1320px;
    margin: 0 auto;
    height: 80px;
    // padding: 26px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo_box {
      cursor: pointer;
      width: 127px;
      height: 28px;
      background-image: url(../../static/images/logo.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .nav_ul {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 100%;

      & > li {
        position: relative;
        cursor: pointer;
        padding: 0 27px;
        line-height: 80px;

        div {
          span {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            font-weight: normal;
            line-height: 28px;
          }

          span:hover {
            color: #ff6633;
          }
        }

        & > .active {
          .normal_text {
            color: #ff6633;
          }
        }

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          margin-right: 0;
          padding-right: 0;
        }
      }
    }
  }

  &.gradual {
    background-image: linear-gradient(90deg, #273146 0%, #2d4981 100%),
      linear-gradient(#282d37, #282d37);
    background-blend-mode: normal, normal;
    box-shadow: 0px 2px 12px 0px rgba(63, 124, 247, 0.1);
  }
  &.bgfff {
    background: #fff !important;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.16);
  }
}
.c_fff {
  color: #fff;
}
.c_333 {
  color: #333;
}
.orange_up {
  margin-top: -14px;
  margin-left: 56px;
  display: block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 14px solid #ff6633; /* 橘色 */
}
</style>



// WEBPACK FOOTER //
// src/components/PageNav.vue